import axios from 'axios'

const state = {
  configFile: {}
}

// getters
const getters = {
  configFile: state => state.configFile
}

// actions
const actions = {
  async getConfig ({ commit }, data) {
    try {
      const response = await axios.get('config.json')
      commit('SET_CONFIG_FILE', response.data)
      return response.data
    } catch (error) {
      return error
    }
  }
}

// mutations
const mutations = {
  'SET_CONFIG_FILE' (state, payload) {
    state.configFile = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
